module.exports = __webpack_public_path__ + "img/police.a563197b.png";